/**
 * UI-related constants
 */

// Band options
export const BAND_OPTIONS = [
  { label: '3 GHz', value: '3' },
  { label: '5 GHz', value: '5' },
  { label: '6 GHz', value: '6' },
] as const;

// Heatmap options
export const HEATMAP_OPTIONS = [
  { label: 'Confidence', value: 'confidence' },
  { label: 'Path Loss', value: 'path_loss' },
  { label: 'Speed', value: 'link_speed' },
] as const;

// Height options
export const HEIGHT_OPTIONS = [
  { label: '3 m / 10 m', value: '3_10' },
  { label: '2 m / 7 m', value: '2_7' },
  { label: '1 m / 5 m', value: '1_5' },
] as const;

// Default active bands
export const DEFAULT_ACTIVE_BANDS = ['3', '5', '6'] as const;

// Base node options
export const BASE_NODE_OPTIONS = {
  ALL: 'all',
  NEAREST: 'nearest',
  USE_SPECIFIC: 'use_specific',
} as const;

// Remote node input modes
export const REMOTE_NODE_INPUT_MODES = {
  ADDRESS: true,
  COORDINATES: false,
} as const;

// Form default values
export const FORM_DEFAULTS = {
  BASE_NODE_OPTION: 'all',
  REMOTE_NODE_FIND_BY_ADDRESS: true,
  EMPTY_STRING: '',
} as const;

// Timeouts and delays
export const TIMEOUTS = {
  ERROR_CLEAR_DELAY: 5000,
  DEBOUNCE_FIND_BNS: 500,
  MAP_EASE_DURATION: 500,
} as const;

// UI dimensions
export const UI_DIMENSIONS = {
  FORM_PANEL_WIDTH: 400,
  FORM_PANEL_MAX_HEIGHT: 'calc(100vh - 96px)',
  SITE_INFO_PANEL_WIDTH: 500,
  SITE_INFO_PANEL_MAX_HEIGHT: 'calc(100vh - 360px)',
  HEATMAP_LEGEND_WIDTH: 80,
  HEATMAP_LEGEND_HEIGHT: 124,
  FILTER_CONTROLS_MIN_WIDTH: 200,
} as const;

// Maximum base nodes to display per site
export const MAX_BASE_NODES_PER_SITE = 8;
